export default {
    login: 'Login',
    logout: 'Logout',
    signIn: 'Anmelden',
    stayLoggedIn: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    registerHere: 'Hier registrieren',
    noAccountQuestion: 'Noch kein Account?',
    pleaseWait: 'Bitte warten',
    register: 'Registrieren',
    registerText: 'Noch keinen Account?',
    registerCallToAction: 'Jetzt registrieren',

    impersonationAborted: 'Die Support Sitzung musste abgebrochen werden.',
    impersonationError: 'Bei der Support Sitzung ist ein Fehler aufgetreten.',
    sessionTimeout: 'Ihre Sitzung ist abgelaufen.',
    pleaseLoginAgain: 'Bitte melden Sie sich erneut an.',

    email: 'E-Mail',
    phone: 'Telefon',
    password: 'Passwort',
    repeatPassword: 'Passwort wiederholen',
    savePassword: 'Passwort speichern',
    pleaseEnterNewPassword: 'Bitte geben Sie ein neues Passwort ein.',
    firstname: 'Vorname',
    lastname: 'Nachname',
    organisation: 'Organisation',
    memberOrganisation: 'Mitgliedsorganisation',
    organisationHelpText: 'Um sich registrieren zu können, müssen Sie den Authentifizierungscode Ihrer Organisation erhalten haben und hier eingeben.',
    associationContactLabel: 'Kontakt aej',
    associationContact: 'Wenn Sie keinen Authentifizierungscode haben, wenden Sie sich bitte an die aej oder eine unserer Mitgliedsorganisationen.',
    associationNoContactPerson: 'Es ist keine Kontaktperson für die aej hinterlegt.',
    memberOrganisationNoContactPerson: 'Es ist keine Kontaktperson für diese Mitgliedsorganisation hinterlegt.',

    privacyNoticeAcknowledged: 'Ich habe die folgende Information zur Kenntnis genommen:',
    privacyNoticeLink: 'Information zur Datenverarbeitung gemäß § 17 DSG-EKD',
    privacyNoticeRequired: 'Bitte bestätigen Sie, dass Sie die Information zur Datenverarbeitung zur Kenntnis genommen haben.',
    privacyNoticeModalTitle: 'Information zur Datenverarbeitung',
    privacyNoticeModalText: 'Bitte lesen Sie die Information zur Datenverarbeitung gemäß § 17 DSG-EKD beim KJP-Antragsverfahren und bestätigen Sie, dass Sie sie zur Kenntnis genommen haben.',
    privacyNoticeModalButton: 'Zur Kenntnis genommen',

    emailVerified: 'E-Mailadresse wurde erfolgreich bestätigt.',

    back: 'Zurück',
    forgotPasswordText:
        'Bitte geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen dann einen Link zum Zurücksetzen Ihres Passworts zu.',
    forgotPasswordSuccess: 'Es wurde eine E-Mail zum Zurücksetzen des Passworts an Ihre E-Mail-Adresse gesendet.',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordSuccessTitle: 'Ihr Passwort wurde erfolgreich geändert',
    resetPasswordSuccessText: 'Sie können sich jetzt mit dem neuen Passwort anmelden.',
}
